module.exports = "/images/air-quality@3x.png?2e4a4f16b3c24128d2f3af2e9c310264";